export default __webpack_public_path__ + "static/media/1400.340721aa.png";